import { ButtonLink } from "../atoms/Buttons";
import { InternalLinkIcon } from "../atoms/Icons";

export default function SearchCard({ title, text, href,translations }) {
  return (
    <div className="search-card col-span-4 640:col-span-6 1024:col-span-6">
      <div className="flex flex-col h-full gap-y-20 py-20 640:py-40 border-b border-gray-300">
        <div className="flex flex-col gap-y-4">
          {title && (
            <span className="block text-18 font-medium leading-145 tracking-05">
              {title}
            </span>
          )}
          {text && (
            <span className="block text-xs-paragraph leading-145">{text}</span>
          )}
        </div>
        <ButtonLink
          text={translations['know_more']}
          href={href}
          icon={<InternalLinkIcon extraClass="stroke-theme-color" />}
        />
      </div>
    </div>
  );
}
